import React from 'react';
import styled from 'styled-components';
import Accordion from '../../Accordion';
import { SCREEN_SIZE } from '../../../lib/mediaQuery';

// SVG's
import Graphic from './FairPriceApp/graphic.svg';
import Graphic2 from './FairPriceApp/graphic2.svg';
import Graphic3 from './FairPriceApp/graphic3.svg';
import Graphic4 from './FairPriceApp/graphic4.svg';

export const FAIR_PRICE_FIELD = [
  {
    image: Graphic,
    title: 'STEP 1',
    titleContent: 'Add vouchers at Payment page',
    subTitle: 'Tap ‘Add’ next to Voucher code',
  },
  {
    image: Graphic2,
    title: 'STEP 2',
    titleContent: 'Use your stored vouchers',
    subTitle: 'Select one or more vouchers you would like to use',
  },
];

export const CASHIER_FIELD = [
  {
    image: Graphic3,
    title: '',
    subTitle:
      'Open the available voucher in your app or mobile browser, and show the QR code to the cashier',
  },
];

export const SELF_CHECKOUT_FIELD = [
  {
    image: Graphic4,
    title: '',
    subTitle:
      'Open the available voucher in your app or mobile browser. When selecting payment type at the kiosk:',
  },
];

export const StyledSubtitle = styled.div`
  line-height: 1.5rem;
  color: var(--bold-title-color);
  font-weight: 700;
  font-size: 20px;
  text-align: center;

  ${SCREEN_SIZE.From.Tablet} {
    text-align: left;
  }
`;

export const StyledTitle = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  text-transform: uppercase;

  ${SCREEN_SIZE.From.Tablet} {
    text-align: left;
  }
`;

export const StyledText = styled.div`
  position: block;
  align-self: center;
  margin-left: 16px;
  margin-top: 4px;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #333333;
  text-align: center;

  ${SCREEN_SIZE.From.Tablet} {
    text-align: left;
  }
  ${SCREEN_SIZE.Below.Tablet} {
    margin-top: 16px;
  }
`;

export const StyledImgWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 1rem 0;

  ${SCREEN_SIZE.From.Tablet} {
    justify-content: flex-start;
    padding-left: 1rem;
  }
  ${SCREEN_SIZE.Below.Tablet} {
    flex-direction: column;
    img {
      align-self: center;
    }
  }
`;

export const StyledLine = styled.div`
  width: auto;
  height: 1px;
  background: #eaeaea;
  margin: 24px 0;
  flex-grow: 0;
`;

const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledOrderedList = styled.div`
  text-align: center;
  list-style-position: inside;
  margin-left: -32px;

  li:not(:last-child) {
    margin-bottom: 5px;
  }

  ${SCREEN_SIZE.From.Tablet} {
    text-align: left;
  }
`;

const HowToRedeemViaFairPriceApp = ({ expand }) => {
  return (
    <Accordion title="How to redeem via FairPrice app" expand={expand}>
      <FlexContainer />
    </Accordion>
  );
};

export default HowToRedeemViaFairPriceApp;
